import { defineStyleConfig } from '@chakra-ui/react';

const Card = defineStyleConfig({
  baseStyle: (props) => ({
    container: {
      bg: props.colorMode === 'dark' ? 'surface.darkContent' : 'surface.content',
      color: props.colorMode === 'dark' ? 'ink.inverted' : 'ink.primary',
      borderRadius: 'lg',
      // Longhands preserve borderColor when merged with Chakra's base theme.
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
      boxShadow: 'none',
    },
    header: {
      padding: { base: '1rem 1rem 0.75rem', md: '1.5rem 1.5rem 0.75rem' },
      borderBottom: '1px solid',
      borderBottomColor: props.colorMode === 'dark' ? 'gray.600' : '#E5E7EB',
    },
    body: {
      padding: { base: '1rem', md: '1.5rem' },
    },
    footer: {
      padding: { base: '0.75rem 1rem 1rem', md: '0.75rem 1.5rem 1.5rem' },
      borderTop: '1px solid',
      borderTopColor: props.colorMode === 'dark' ? 'gray.600' : '#E5E7EB',
    },
  }),
});

export default Card;
